import { render, staticRenderFns } from "./addMaterialDia.vue?vue&type=template&id=2a419fa1&scoped=true"
import script from "./addMaterialDia.vue?vue&type=script&lang=js"
export * from "./addMaterialDia.vue?vue&type=script&lang=js"
import style0 from "./addMaterialDia.vue?vue&type=style&index=0&id=2a419fa1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a419fa1",
  null
  
)

export default component.exports